// extracted by mini-css-extract-plugin
export var button = "_98-0";
export var icon = "_98-1";